module.exports = {
  title: 'Access Code',
  table: {
    title: {
      index: 'No',
      code: 'Code',
      subscriptionPlan: 'Plan',
      subscriptionDuration: 'Duration',
      userUsed: 'User Name',
      target: 'Target',
      expirationDate: 'Expiration Date',
      usedDate: 'USAGE DATE',
      createdAt: 'Created Date',
      email: 'Email',
      status: 'Status',
      action: 'Action',
    },
  },
  btnGenerate: 'Create',
  btnExport: 'Export',
  header: {
    generate: 'Create Access Code',
    generateOnlyCode: 'Create Only One Access Code',
    generateMultiCode: 'Create Multi Access Code',
    buttonExport: 'Export to CSV',
  },
  form: {
    subscriptionPlan: 'Subscription plan',
    subscriptionDuration: 'Subscription duration',
    quantity: 'Quantity',
    code: 'Code',
    status: 'Status',
    byMonth: '(by month)',
    target: 'Purpose',
    targetPlaceholder: 'Purpose (Ex: VIP, Employee...)',
    selectTarget: 'Select a purpose',
  },
  validate: {
    subscriptionDurationBlank: 'Please input subscription duration.',
    quantityBlank: 'Please input quantity.',
  },
  plan: {
    champion: 'Champion',
    legend: 'Legend',
    random: 'Random',
    all: 'All',
  },
  duration: {
    random: 'Random',
    input: 'Input duration (by month)',
    monthly: 'Monthly',
    yearly: 'Yearly',
    all: 'All',
  },
  tooltip: {
    planChampion: 'Only plan Champion',
    planLegend: 'Only plan Legend',
    planRandom: 'Random plan Champion or Legend',
    durationRandom: 'Random subscription duration',
    inputRandom: 'Input duration',
    exportAll: 'All code',
    exportUnused: 'Unused codes',
    exportUsed: 'Used codes',
    allPlan: 'All plan',
    allDuration: 'All duration',
    target: 'Target',
    monthly: 'Monthly',
    yearly: 'Yearly',
    deactivate: 'Deactivate',
    exportCodeAvailable: 'Access codes available',
    exportCodeActive: 'Access codes active',
    exportCodeInactive: 'Access codes inactive',
    exportCodeExpired: 'Access codes expired',
  },
  message: {
    errorGenerateOnly: 'Failed to create access code.',
    successGenerateOnly: 'Access code successfully created.',
    errorExport: 'Failed to export access code.',
    successExport: 'Access code successfully exported.',
    deactivateSuccess: 'Access code successfully deactivated.',
  },
  filter: {
    searchPlaceholder: 'Search code, name or email',
  },
  used: {
    all: 'All',
    notUsed: 'Unused',
    used: 'Used',
  },
  popup: {
    title: 'Confirm',
    okBtn: 'Yes',
    cancelBtn: 'No',
    deactivate: 'Are you sure you want to deactivate this access code?',
    confirmPassword: 'Please input your password to confirm.',
  },
};
